import { useLayoutEffect } from 'react'

import { COLORS } from '~/shared/constants/uiConstants'

export const useMatchHeaderBackground = (): void => {
  useLayoutEffect(() => {
    document.documentElement.style.setProperty('--header-bg', COLORS.GRAY_100)

    return () => {
      document.documentElement.style.removeProperty('--header-bg')
    }
  }, [])
}
